import { useMutation, useQueryClient } from '@tanstack/react-query';
import * as authApi from '@/api/auth';
import { setTokens } from '@/lib/auth';
import { useAuthContext } from '@/contexts/auth-context';
import type { LoginInput, RegisterInput, ChangePasswordInput } from '@/types/auth';

export function useLogin() {
  const { setUser } = useAuthContext();
  return useMutation({
    mutationFn: (input: LoginInput) => authApi.login(input),
    onSuccess: (data) => {
      setTokens(data.tokens.access_token, data.tokens.refresh_token);
      setUser(data.user);
    },
  });
}

export function useRegister() {
  const { setUser } = useAuthContext();
  return useMutation({
    mutationFn: (input: RegisterInput) => authApi.register(input),
    onSuccess: (data) => {
      setTokens(data.tokens.access_token, data.tokens.refresh_token);
      setUser(data.user);
    },
  });
}

export function useChangePassword() {
  return useMutation({
    mutationFn: (input: ChangePasswordInput) => authApi.changePassword(input),
  });
}

export function useLogout() {
  const { logout } = useAuthContext();
  const queryClient = useQueryClient();
  return () => {
    queryClient.clear();
    logout();
  };
}
